<template>
  <v-container id="project-summary" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <idc-component-bid-summary :type="status" :statuses="bidStatuses" :title="title" :sub-header="subHeader" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import { ManagementStatus } from '@/utilities/bid/enums/Status'

  export default Vue.extend({
    name: 'DashboardCompletedSummary',
    components: {
      IdcComponentBidSummary: () => import('@/components/idc/bids/Summary'),
    },
    props: {
      bidStatuses: {
        type: Array,
        default: () => [24],
      },
    },
    data: () => ({
      status: ManagementStatus.STATUS_TYPE_LIVE,
      title: 'Completed Project Summary',
      subHeader: 'Completed Projects',
    }),
  })
</script>

<style lang="sass">
  section#project-summary
    .v-card--material
      &__heading.success
        background-color: $dark-red-colour !important
        border-color: $dark-red-colour !important
</style>
